import { useEffect, useRef, useState } from "react";
import SyncFusionDatePicker from "../Pages/Components/SyncFusionDateTimePicker/SyncFusionDatePicker";
import "../styles/filter.css";

export const DateFilter = (props) => {
  const dropdownRef = useRef(null);
  const [isOpen, setIsOpen] = useState(false);


  // Fecha o dropdown ao clicar fora
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    if (isOpen) document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isOpen]);

  return (
    <>
      {/* CSS para animação do spinner */}
      <style>
        {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>
      <div className="filter" ref={dropdownRef}>
        <div>
          <span className="title">{props.title}</span>
        </div>
        <div className="filter-select-container field-data">
          <SyncFusionDatePicker
            format="dd/MM/yy"
            id={props.id}
            value={props.value}
            onChange={props.handleCallback}
            disabled={props.underMaintenace === "N"}
            placeholder={props.placeholder}
            step={props.step}
          />
        </div>
      </div>
    </>
  );
};
